import { jsx as _jsx } from "react/jsx-runtime";
const ChevronRight = props => (_jsx("svg", { width: "6px", height: "10px", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 10", ...props, children: _jsx("path", { d: "M.2 9.8c-.3-.3-.3-.9 0-1.2L3.8 5 .2 1.4C-.1 1.1-.1.5.2.2c.3-.3.9-.3 1.2 0l4.2 4.2c.3.3.3.9 0 1.2L1.4 9.8c-.1.1-.4.2-.6.2-.2 0-.4-.1-.6-.2z" }) }));
export default ChevronRight;
